<script>
import Particles from '@/components/particles.vue';

export default {
  name: 'Layout',
  components: {
    Particles,
  },
};
</script>

<template>
  <div class="layout">
    <Particles class="particles-background" />
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.layout {
  position: relative;
  width: 100%;
  min-height: 100vh; /* Ensure it adapts to the content height */
  background-image: url('@/assets/images/auth-one-bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
}

.particles-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0; /* Ensure it is behind other content */
  touch-action: none; /* Prevents pinch-zooming */
}

.content {
  position: relative;
  z-index: 1; /* Ensure other content is above the particles */
  width: 100%;
}
</style>
